import { get as _get } from "lodash";
import { loadTokenData } from "../utils/token";
import { regexBtcAddress } from "../utils/regex";
import { CONFIG_BASE } from "./../constants/configs";
// contracts
import { PeripheryContract } from "./contracts";

// helpers
import LS from "./storage";

// request
import TokensService from "./../services/tokens";

const getTokenList = async () => {
  let tokensService = new TokensService();
  switch (import.meta.env.VITE_CHAIN) {
    case "MAINNET":
      return tokensService.getMainnet();
    case "HARBINGER":
      return tokensService.getHarbinger();
    default:
      return {};
  }
};

// the periphery config rarely changes, it is requested once per session
let swapConfigRequest = null;
const getSwapConfig = () => {
  if (!swapConfigRequest) {
    swapConfigRequest = PeripheryContract()
      .functions.get_config()
      .catch((error) => {
        swapConfigRequest = null;
        throw error;
      });
  }
  return swapConfigRequest;
};

/**
 * Initializes the tokens from the token list api and localstorage
 * @returns
 */
export const InitializeTokens = async () => {
  let result = {
    loading: false,
    base_tokens: [],
    custom_tokens: [],
  };

  try {
    let tokensResult = await getTokenList();

    let tokensFinal = _get(tokensResult, "tokens", []);

    let custom_tokens = JSON.parse(LS.getItemDevice("custom_tokens"));
    let _custom_tokens = [];
    if (custom_tokens) {
      // remove duplicate tokens from storage if added to token list;
      for (let index = 0; index < custom_tokens.length; index++) {
        const _token = custom_tokens[index];
        let tokenExist = tokensFinal.find((t) => t.address == _token.address);
        if (!tokenExist) {
          _custom_tokens.push(_token);
        }
      }
      if (custom_tokens.length != _custom_tokens.length) {
        LS.custom_tokens(_custom_tokens);
      }
    }
    result = {
      loading: false,
      base_tokens: tokensFinal,
      custom_tokens: _custom_tokens,
    };
  } catch (error) {
    console.log(error);
  }
  return result;
};

/**
 * Initialize the token Pairs
 * @returns
 */
export const InitializeSwaps = async () => {
  const currentUrl = new URL(window.location.href);
  let result = {
    loading: false,
    timing: Date.now(),
    configs: {
      feeOn: false,
      feeTo: "",
    },
    send: null,
    received: null,
  };
  try {
    let tokensResult = await getTokenList();

    let tokensFinal = _get(tokensResult, "tokens", []);

    let input = currentUrl.searchParams.get("input");
    let output = currentUrl.searchParams.get("output");
    let inputToken = await getTokenFromList(CONFIG_BASE.tokens.send, input, tokensFinal);
    let outputToken = await getTokenFromList(CONFIG_BASE.tokens.received, output, tokensFinal);

    let _configs = await getSwapConfig();
    let _results = _get(_configs, "result", {});

    // result
    result = {
      loading: false,
      timing: Date.now(),
      configs: {
        feeOn: _get(_results, "feeOn", false),
        feeTo: _get(_results, "feeTo", ""),
      },
      send: inputToken,
      received: outputToken,
    };
  } catch (error) {
    console.log(error);
  }
  return result;
};

/**
 * The token of the list with this address, else the token read from its contract (a valid address), else the
 * default; KOIN and VHP are in the list by name ("koin", "vhp"), not by a contract address
 * @param {string} defaultToken
 * @param {string} address
 * @param {Array} existingTokens
 * @returns
 */
const getTokenFromList = async (defaultToken = null, address, existingTokens) => {
  if (address == null || address == "") {
    return defaultToken;
  }
  const listed = existingTokens.find((t) => t.address == address);
  if (listed) {
    return listed;
  }
  return regexBtcAddress(address) ? loadTokenData(address) : defaultToken;
};
